var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M24 45C35.598 45 45 35.598 45 24C45 12.402 35.598 3 24 3C12.402 3 3 12.402 3 24C3 35.598 12.402 45 24 45Z",
    stroke: "#0078D4",
    strokeWidth: 6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#0078D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 23C30.6297 23 30.9435 23.2822 30.9932 23.6482L31 23.75V24.25C31 27.8094 28.245 30.7254 24.751 30.9817L24.75 33.25C24.75 33.6642 24.4142 34 24 34C23.6203 34 23.3065 33.7178 23.2568 33.3518L23.25 33.25L23.25 30.9818C19.8332 30.7316 17.1228 27.938 17.0041 24.4863L17 24.25V23.75C17 23.3358 17.3358 23 17.75 23C18.1297 23 18.4435 23.2822 18.4932 23.6482L18.5 23.75V24.25C18.5 27.077 20.7344 29.3821 23.5336 29.4956L23.75 29.5H24.25C27.077 29.5 29.3821 27.2656 29.4956 24.4664L29.5 24.25V23.75C29.5 23.3358 29.8358 23 30.25 23ZM24 14C26.2091 14 28 15.7909 28 18V24C28 26.2091 26.2091 28 24 28C21.7909 28 20 26.2091 20 24V18C20 15.7909 21.7909 14 24 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/Speaker.65c7b360d468f65b014c046993bda897.svg";
export { ForwardRef as ReactComponent };